import { render, staticRenderFns } from "./InstallmentList.vue?vue&type=template&id=0a6b032c&scoped=true&"
import script from "./InstallmentList.vue?vue&type=script&lang=js&"
export * from "./InstallmentList.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentList.vue?vue&type=style&index=0&id=0a6b032c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b032c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
